import Vue from 'vue'
import Vuex from 'vuex'
import fb from './firebaseConfig'

Vue.use(Vuex)

/*
fb.auth.onAuthStateChanged(user => {
  if (user) {
    store.dispatch('fetchRapportCommercial')
  }
})
*/
function getMonthValue(source, month) {
  if(!month) {
    month = store.state.lastUpdate.getMonth()
  }

  let result = 0

  if(Array.isArray(source)) {
    if(source.length-1 >= month) {
      result = source[month]
    } else {
      result = source[source.length-1]
    }
  } else {
    result = source
  }
  
  return result
}

function getIndicator(rapport, agence, name, month) {
  if(!rapport) return 1

  if(!agence) {
    return getMonthValue(rapport[name], month)
  }

  return rapport.byAgence.reduce( function(total, current) {
    let result = total

    if((current.agence === agence || agence === 'Toutes') && current[name]) {
      result += getMonthValue(current[name], month)
    }
    
    return result
  }, 0)
}

function getSerie(rapport, agence, name) {
  if(!rapport) return 1

  if(!agence) {
    return rapport[name]
  }

  if(agence !== 'Toutes') {
    let agenceData = rapport.byAgence.find(e => e.agence === agence)
    if(!agenceData) {
      return []
    } else {
      return agenceData[name]
    }
  } else {
    return rapport.byAgence.reduce(function(total, current) {
      let serie = current[name]
      if(!serie) {
        return total
      }

      let length = Math.max(total.length, serie.length)
  
      for (let index = 0; index < length; index++) {
        if(total[index]) {
          total[index] += serie[index]
        } else {
          total[index] = serie[index]
        }        
      }
      
      return total
    }, [])
  }


}

export const store = new Vuex.Store({
    state: {
      rapportCommercial: null,
      rapportPromotion: null,
      rapportFinancier: null,
      rapportRh: null,
      lastUpdate: null,
      loading: false,
      user: null,
    },
    getters: {
      indicateurNeuf: (state) => (agence, name, month) => {
        if(!state.rapportCommercial) return 1

        return getIndicator(state.rapportCommercial.neuf, agence, name, month)
      },
      serieNeuf: (state) => (agence, name) => {
        if(!state.rapportCommercial) return 1

        return getSerie(state.rapportCommercial.neuf, agence, name)
      },
      indicateurAncien: (state) => (name, month) => {
        if(!state.rapportCommercial) return 1

        return getIndicator(state.rapportCommercial.ancien, null, name, month)
      },
      serieAncien: (state) => (name) => {
        if(!state.rapportCommercial) return 1

        return getSerie(state.rapportCommercial.ancien, null, name)
      },
      indicateurSyndic: (state) => (name, month) => {
        if(!state.rapportCommercial) return 1

        return getIndicator(state.rapportCommercial.syndic, null, name, month)
      },
      serieSyndic: (state) => (name) => {
        if(!state.rapportCommercial) return 1

        return getSerie(state.rapportCommercial.syndic, null, name)
      },
      indicateurGestion: (state) => (name, month) => {
        if(!state.rapportCommercial) return 1

        return getIndicator(state.rapportCommercial.gestion, null, name, month)
      },
      serieGestion: (state) => (name) => {
        if(!state.rapportCommercial) return 1

        return getSerie(state.rapportCommercial.gestion, null, name)
      },
      indicateurLoc: (state) => (name, month) => {
        if(!state.rapportCommercial) return 1

        return getIndicator(state.rapportCommercial.location, null, name, month)
      },
      serieLoc: (state) => (name) => {
        if(!state.rapportCommercial) return 1

        return getSerie(state.rapportCommercial.location, null, name)
      },
      indicateurPromotion: (state) => (agence, name, month) => {
        if(!state.rapportPromotion) return 1

        return getIndicator(state.rapportPromotion, agence, name, month)
      },
      seriePromotion: (state) => (agence, name) => {
        if(!state.rapportPromotion) return 1

        return getSerie(state.rapportPromotion, agence, name)
      },
      indicateurRh: (state) => (name, month) => {
        if(!state.rapportRh) return 1

        return getIndicator(state.rapportRh, null, name, month)
      },
      serieRh: (state) => (name) => {
        if(!state.rapportRh) return 1

        return getSerie(state.rapportRh, null, name)
      },
      indicateurFinancier: (state) => (name, month) => {
        if(!state.rapportFinancier) return 1

        return getIndicator(state.rapportFinancier, null, name, month)
      },
      serieFinancier: (state) => (name) => {
        if(!state.rapportFinancier) return 1

        return getSerie(state.rapportFinancier, null, name)
      },
      decaissementsLibelles: (state) => (index) => {
        if(!state.rapportFinancier) return []

        return state.rapportFinancier.decaissements[index].libelles
      },
      decaissementsValues: (state) => (index) => {
        if(!state.rapportFinancier) return []

        return state.rapportFinancier.decaissements[index].values
      },
      rentaLibelles: (state) => () => {
        if(!state.rapportFinancier) return []

        return state.rapportFinancier.rentabilite.slice().sort((a, b) => b.taux - a.taux).map(e => e.libelle)
      },
      rentaTaux: (state) => () => {
        if(!state.rapportFinancier) return []

        return state.rapportFinancier.rentabilite.slice().sort((a, b) => b.taux - a.taux).map(e => Math.round(e.taux * 100))
      },
      rentaNet: (state) => () => {
        if(!state.rapportFinancier) return []

        return state.rapportFinancier.rentabilite.slice().sort((a, b) => b.taux - a.taux).map(e => Math.round(e.net))
      },
    },
    actions: {
      fetchRapportCommercial({ commit }) {
        return new Promise((resolve) => {
          if(!store.state.rapportCommercial) {
            // If localStorage contains report get it and display datas
            let rapport = JSON.parse(localStorage.getItem('rapportCommercial'))
            if(rapport)
            {
              commit('setRapportCommercial', rapport)
              commit('setLastUpdate', JSON.parse(localStorage.getItem('lastUpdate')))
              resolve()
            }
            // Get update anyway
            let date = new Date()
            fb.rapportsCollection.doc('commercial' + date.getFullYear()).onSnapshot(function(doc) {
              if(doc.exists) {
                commit('setRapportCommercial', doc.data())
                commit('setLastUpdate', doc.data().timestamp)
                localStorage.setItem('rapportCommercial', JSON.stringify(rapport))
                localStorage.setItem('lastUpdate', JSON.stringify(doc.data().timestamp))
              }
              // Waiting for update only if nothing is cached
              if(!rapport) {
                resolve()
              }
            },  function(error) {
              console.log('error ' + error)
            })
          } else {
            resolve()
          }
        })   
      },
      fetchRapportPromotion({ commit }) {
        return new Promise((resolve) => {
          if(!store.state.rapportPromotion) {
            // If localStorage contains report get it and display datas
            let rapport = JSON.parse(localStorage.getItem('rapportPromotion'))
            if(rapport)
            {
              commit('setRapportPromotion', rapport)
              commit('setLastUpdate', JSON.parse(localStorage.getItem('lastUpdate')))
              resolve()
            }
            // Get update anyway
            let date = new Date()
            fb.rapportsCollection.doc('promotion' + date.getFullYear()).onSnapshot(function(doc) {
              if(doc.exists) {
                commit('setRapportPromotion', doc.data())
                commit('setLastUpdate', doc.data().timestamp)
                localStorage.setItem('rapportPromotion', JSON.stringify(rapport))
                localStorage.setItem('lastUpdate', JSON.stringify(doc.data().timestamp))
              }
              // Waiting for update only if nothing is cached
              if(!rapport) {
                resolve()
              }
            },  function(error) {
              console.log('error ' + error)
            })
          } else {
            resolve()
          }
        })
      },
      fetchRapportRh({ commit }) {
        return new Promise((resolve) => {
          if(!store.state.rapportRh) {
            // If localStorage contains report get it and display datas
            let rapport = JSON.parse(localStorage.getItem('rapportRh'))
            if(rapport)
            {
              commit('setRapportRh', rapport)
              commit('setLastUpdate', JSON.parse(localStorage.getItem('lastUpdate')))
              resolve()
            }
            // Get update anyway
            let date = new Date()
            fb.rapportsCollection.doc('rh' + date.getFullYear()).onSnapshot(function(doc) {
              if(doc.exists) {
                commit('setRapportRh', doc.data())
                commit('setLastUpdate', doc.data().timestamp)
                localStorage.setItem('rapportRh', JSON.stringify(rapport))
                localStorage.setItem('lastUpdate', JSON.stringify(doc.data().timestamp))
              }
              // Waiting for update only if nothing is cached
              if(!rapport) {
                resolve()
              }
            },  function(error) {
              console.log('error ' + error)
            })
          } else {
            resolve()
          }
        })
      },
      fetchRapportFinancier({ commit }) {
        return new Promise((resolve) => {
          if(!store.state.rapportFinancier) {
            // If localStorage contains report get it and display datas
            let rapport = JSON.parse(localStorage.getItem('rapportFinancier'))
            if(rapport)
            {
              commit('setRapportFinancier', rapport)
              commit('setLastUpdate', JSON.parse(localStorage.getItem('lastUpdate')))
              resolve()
            }
            // Get update anyway
            let date = new Date()
            fb.rapportsCollection.doc('financier' + date.getFullYear()).onSnapshot(function(doc) {
              if(doc.exists) {
                commit('setRapportFinancier', doc.data())
                commit('setLastUpdate', doc.data().timestamp)
                localStorage.setItem('rapportFinancier', JSON.stringify(rapport))
                localStorage.setItem('lastUpdate', JSON.stringify(doc.data().timestamp))
              }
              // Waiting for update only if nothing is cached
              if(!rapport) {
                resolve()
              }
            },  function(error) {
              console.log('error ' + error)
            })
          } else {
            resolve()
          }
        })
      },
      fetchUser ({ commit }) {
        return new Promise((resolve) => {
          if(!store.state.user) {
            // If localStorage contains report get it and display datas
            let user = JSON.parse(localStorage.getItem('user'))
            if(user) {
              commit('setUser', user)
              resolve()
            }

            fb.usersCollection.doc(fb.auth.currentUser.uid).get().then(function(doc) {
              let data = doc.data()
              commit('setUser', data)
              localStorage.setItem('user', JSON.stringify(data))

              // Waiting for update only if nothing is cached
              if(!user) {
                resolve()
              }
            },  function(error) {
              console.log('error ' + error)
            })

          } else {
            resolve()
          }
          
        })
      }
    }, 
    mutations: {
      setRapportCommercial(state, rapport) {
        state.rapportCommercial = rapport
      },
      setRapportPromotion(state, rapport) {
        state.rapportPromotion = rapport
      },
      setRapportRh(state, rapport) {
        state.rapportRh = rapport
      },
      setRapportFinancier(state, rapport) {
        state.rapportFinancier = rapport
      },
      setLastUpdate(state, timestamp) {
        state.lastUpdate = new Date(timestamp.seconds * 1000)
      },
      setLoading(state) {
        state.loading = true
      },
      setLoaded(state) {
        state.loading = false
      },
      setUser(state, user) {
        state.user = user
      },
      clear (state) {
        state.rapportCommercial = null,
        state.rapportPromotion = null,
        state.rapportFinancier = null,
        state.rapportRh = null,
        state.lastUpdate = null,
        state.user = null
        localStorage.clear()
      }
    }
})